import { ReactNode } from 'react';

import { Box, SxProps } from '@mui/material';

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
  sx?: SxProps;
  className?: string;
  containerSX?: SxProps;
}

const CustomTabPanel = ({
  children,
  value,
  index,
  sx,
  className,
  containerSX,
  ...other
}: TabPanelProps) => {
  return (
    <Box
      aria-labelledby={`tab-${index}`}
      className={className}
      hidden={value !== index}
      id={`tabpanel-${index}`}
      role='tabpanel'
      sx={containerSX}
      {...(other as any)}
    >
      {value === index && <Box sx={{ ...sx }}>{children}</Box>}
    </Box>
  );
};

export default CustomTabPanel;
